import { useTheme } from '@mui/material/styles'
import { useMediaQuery } from '@mui/material'

function Education () {
  const theme = useTheme()
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <article
      style={{
          borderTop: '1px solid ' + theme.palette.lightGrey,
          display: 'flex',
          flexDirection: 'column',
          gap: '40px'
      }}
    >
      <h2
        style={{
          color: theme.palette.darkGrey,
          paddingTop: '28px'
        }}
      >
          Education
      </h2>
      <section
       style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '16px',
          marginBottom: '8px',
          ...isMediumScreen && { flexDirection: 'column-reverse', gap: '4px' },
        }}
      >
        <p
          style={{
            color: theme.palette.darkGrey,
            ...isMediumScreen && { width: '100%' },
          }}
        >
          <strong>MI, User Experience Design</strong>
          <br/>
          University of Toronto
          <br/>
          Toronto, Ontario
        </p>
        <p style={{ color: theme.palette.darkGrey }}>Expected 2027</p>
      </section>

      <section
       style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '16px',
          marginBottom: '8px',
          ...isMediumScreen && { flexDirection: 'column-reverse', gap: '4px' },
        }}
      >
        <p
          style={{
            color: theme.palette.darkGrey,
            ...isMediumScreen && { width: '100%' },
          }}
        >
          <strong>HBSc, Computer Science and Cell & Systems Biology</strong>
          <br/>
          University of Toronto
          <br/>
          Toronto, Ontario
        </p>
        <p style={{ color: theme.palette.darkGrey,fontWeight: 700 }}>2012</p>
      </section>
    </article>
  )
}

export default Education
